import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {FormGroup} from "@angular/forms";


@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private router: Router,
  ) { }


  /**
   * @desc Displays a toast message of a certain type depending on the param value
   * @param message - the message of the toast to be displayed
   * @param status - the status of the toast ('error' or 'success')
   * @param redirect - if the toast should redirect to a different page
   * @param refresh - if the redirecting should be done by refreshing the page or not
   */
  async toast(message: string, status = 'error', redirect = null,refresh = false) {
    // TODO
  }

  /**
   * @desc Displays an error modal and dismisses it after 1.5 seconds to imitate the behavior of a toast message
   * @param message - the message to be displayed inside the modal
   */
  async errorToast(message: string) {
    // TODO
  }

}
